import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { BaseFieldEditorComponent } from "../../base-field-editor.component";
import { ALLOWED_TYPES, FileUploaderField } from "./file-uploader";

@Component({
    selector: "file-uploader-editor",
    templateUrl: "./file-uploader-editor.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileUploaderEditorComponent extends BaseFieldEditorComponent implements OnInit, OnDestroy {
    allowedTypes = ALLOWED_TYPES;

    constructor(_changeDetector: ChangeDetectorRef, private _formBuilder: FormBuilder) {
        super(_changeDetector);
    }

    ngOnInit(): void {
        this.form = this._formBuilder.group({
            placeholder: new FormControl(this.fileUploaderField.placeholder, []),
            maxNumberOfFiles: new FormControl(this.fileUploaderField.maxNumberOfFiles, [
                Validators.required,
                Validators.min(1),
            ]),
            fileTypes: new FormControl(this.fileUploaderField.fileTypes ?? this.allowedTypes, [Validators.required]),
        });
        super.onInit();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    get fileUploaderField() {
        return this.field as FileUploaderField;
    }
}
